export const HIDDEN_TRUTH = {
  heading: "Whats really in your supplements ?",
  intro: [
    "Please read the ingredients list of your supplements and then look for the sneaky tab/link that says extra/other ingredients. They are all at it.",
    "Also, check everything you put on your skin or hair they are all made by the same companies most of the time (Big Pharma)",
  ],
  them: {
    title: "Them (Big biz/ Big Pharma)",
    body: "If you check the back of your supplement bottle and check the ingredients you will see a combo of these Nasty little extras below. You could check the back of any product you buy as 99% are made for profit and not made for humans.",
    ingredients:
      "DiCalcium Phosphate, Anti-caking Agents,(Silicon Dioxide & Magnesium Stearate),Tablet Coating (Hydroxypropyl Methylcellulose, lycerine),Crosslinked Cellulose Gum, Stearic Acid,Polydextrose,Titanium Dioxide & Iron Oxides Methylcellulose, Stearic Acid, Maltodextrin, Colloidal Andhydrous Silica, Microcrystalline Cellulose,Crosarmellose Sodium, Hypromellose, Glycerol Liquid Glucose, Talc, Sucrose, Silica Colloidal Anhydrous,Cellulose powdered, Calcium carbonate (E1700, Acacia, Tragacanth, white beeswax,Carnaub wax, Shellac, etc etc",
  },
  us: {
    title: "Us (The People)",
    question: "So Chris what do you add to your supplements ????",
    answer: "Nothing - Nasty Free ;)",
    body: [
      "All of our products are 100% of what your looking to buy. So, for example, you're in the market for Milk Thistle extract. Ours is Milk thistle in a veg capsule. There are no sneaky little extras like those to the left. **Update we are adding an uptake blend to most of our products to help with the uptake of each supplement**",
      "They or the factory's they buy from all add these to stop the herbs from being sticky and to help the machines work so they can mass produce them by the millions. It's a regular theme it's all about mass producing to make as much as they can and extract as much money from you as they can.",
      "Most brands don't even make their own products these days any way they buy from a couple of factories. That's why you see the exact same amounts and the same nasty extras most of the time just with a different label on it.",
    ],
  },
  crown: {
    title: "The Crown Jewels have been Sold along time ago",
    lead: "Do you know when you are actually buying a British product these days ? It's actually very hard to buy British because Britain does not own much these days :( Everything has been sold to the highest bidder !",
    note: "Below is just a few businesses that were founded in the UK and are still going strong but are owned by foreigners. Please note when it says owned by the USA etc it means a person or group who is from that country usually. Also, a lot are owned by multiple groups/countries .",
    list: [
      "Holland & Barrett's owned by the Russians",
      "Natures Best owned by Merck KGaA (Big Pharma )",
      "Seven Seas Cod Liver Oil owned by the Germans aswell (Merck KGaA)",
      "British Airways owned by the Spanish",
      "Heathrow Airport now owned by the Spanish 25% and Qatar 20%",
      "Cadburys Chocolate owned by the USA.",
      "P&O Cruises owned by the USA",
      "Rolls Royce owned by the Germans (BMW)",
      "Selfridges owned by the Canadians",
      "Tetley Tea owned by the Indians",
      "Imperial Chemical Industries (Dulux) owned by the Dutch",
      "Walkers Crisps owned by USA",
      "Lea & Perrins Worcestershire sauce owned by USA",
      "Jaffa Cakes owned by Turkey",
      "Harvey Nichols owned by Hong Kong",
      "Kit Kat owned by the Swiss",
      "The Financial Times newspaper is owned by Japan",
      "Marmite is owned by the Dutch",
      "Walls Ice Cream is Dutch owned aswell",
      "Hartley's Jam owned by USA",
      "Most Premier League football teams",
      "Hamleys is owned by China",
      "Waterstones is owned by USA",
      "Innocent drinks are USA owned",
      "Scottish Power is owned by Spain",
      "Thames Water is German/Omers (Canada).",
      "Pilkington Glass is owned by Japan",
      "Abbey National is owned by Spain",
      "Newcastle Brown Ale owned by the Dutch & Danish and even brewed in Holland.",
      "Beefeater Dry Gin owned by France",
      "Harrods owned by the state of Qatar",
      "The Mini is owned by Germany",
    ],
  },
};
